class SiteHeader {
  constructor() {
    // Constructor logic goes here
    this.siteHeader = document.querySelector("header")
    if (!this.siteHeader) return

    this.events()
  }

  events() {
    // Event listeners go here

    window.addEventListener("resize", () => {
      this.getSiteHeaderHeight()
    })

    document.addEventListener("DOMContentLoaded", () => {
      // Code to be executed when the DOM is ready
      // console.log("DOM is ready")
      this.getSiteHeaderHeight()
    })
  }

  // Class methods go here
  getSiteHeaderHeight() {
    const siteHeaderHeight = this.siteHeader.offsetHeight
    document.documentElement.style.setProperty("--site-header-height", `${siteHeaderHeight}px`)
    // console.log("siteHeaderHeight", siteHeaderHeight)
  }
}

export default SiteHeader
